module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/human2-658be791dbfb2a35c5d51932aac87ebf.svg";